import { FabricImage, FabricObject } from 'fabric';

export function isVideoImage(obj: FabricObject): boolean {
  if (obj.type !== 'image') return false;
  const el = (obj as FabricImage).getElement();
  if (el instanceof HTMLVideoElement) return true;
  const id = (obj as FabricObject & { id?: string }).id;
  return typeof id === 'string' && id.startsWith('video_');
}
